module.exports = __webpack_public_path__ + "img/fire01.a80feed7.png";